export function useDebounce(fn, time = 300) {
  let intervel;
  return () => {
    intervel && clearTimeout(intervel);
    intervel = setTimeout(() => {
      clearTimeout(intervel);
      fn && fn();
    }, time);
  };
}
